import styled from "styled-components";

const ThumbnailNumber = styled.div`
  border-radius: 50%;
  border: 4px solid white;
  color: #ffffff;
  font-size: 24px;
  font-weight: 600;
  background-color: #c4c4c4;
  padding: 13px 8px;
  margin-left: 2px;
  letter-spacing: -1px;
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;
`;

export default ThumbnailNumber;